var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "h1",
    { staticClass: "text-center", staticStyle: { width: "100%" } },
    [
      _vm._v("404"),
      _c("br"),
      _vm._v(" Page not found "),
      _c("br"),
      _vm._v(" "),
      _c("router-link", { attrs: { to: "/" } }, [_vm._v(" Home page ")]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }